var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0099 54.2999H67.685C66.7187 59.0514 64.2526 62.9501 60.2825 65.9918C56.3082 69.0376 51.5776 70.5585 46.0867 70.5585C42.5955 70.5585 39.3144 69.9073 36.2349 68.6091C33.1512 67.3109 30.5003 65.5296 28.2737 63.2652C26.047 61.005 24.2993 58.312 23.039 55.1947C21.7744 52.0774 21.1484 48.6997 21.1484 45.0615C21.1484 41.4232 21.7618 38.0665 22.9844 34.9828C24.2111 31.9034 25.9168 29.2314 28.1056 26.967C30.2944 24.7025 32.895 22.9212 35.8988 21.6231C38.4321 20.5308 41.1461 19.9258 44.0197 19.7535V4.90234C38.9068 5.08299 34.0629 6.09968 29.4962 7.98181C24.4464 10.0614 20.0897 12.8972 16.4137 16.4976C12.7377 20.098 9.84305 24.3496 7.72986 29.244C5.60826 34.1468 4.54956 39.4193 4.54956 45.0573C4.54956 50.6953 5.62506 55.9677 7.78027 60.8663C9.93128 65.7649 12.8469 70.0165 16.5229 73.6169C20.199 77.2173 24.5556 80.0573 29.6054 82.1327C34.651 84.2123 40.0706 85.25 45.8598 85.25C51.649 85.25 56.619 84.2291 61.4462 82.1915C66.2692 80.1498 70.4073 77.3686 73.8607 73.8396C77.3141 70.3148 80.0238 66.0842 81.99 61.1436C83.9562 56.2072 84.9392 50.8843 84.9392 45.1665V40.2679H56.0099V54.2999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1531 14.5776H56.0095V30.4045H85.1531V14.5776Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.8b14b452f0a747364a93abf8b4dc21fb.svg";
export { ForwardRef as ReactComponent };